<template>
  <div class="">
	<el-carousel height="400px" :interval="5000" arrow="always">
	    <el-carousel-item v-for="item in 2" :key="item">
	        <div class="slider" :style="`background:#F18655 url(${bgHeader}) 50% bottom no-repeat`">
				<div class="site-info" :style="`background-image: url(${foreHeader});`">
					<div class="site-info__content">
						<div class="title">专业运输管理系统</div>
						<ul class="ulist">
							<li>TMS就选一路高歌PaaS！企业的信赖选择！</li>
							<li>链接运输上下游 在途追踪 大中型企业物流数字化利器</li>
							<li>咨询：<a class="a-white" href="tel:0577-85625556">0577-85625556</a></li>
						</ul>
					</div>
				</div>
			</div>
	    </el-carousel-item>
	</el-carousel>
	<div class="strip-line"></div>
	<div class="sub-title">
		<div class="section">
			<div class="title">一路高歌运输管理云平台 PaaS + TMS + 物流管理</div>
			<div class="items">
				<div class="icon-box" v-for="(item,index) in iconList">
					<el-image :src="item.icon" style="width:64px;height:64px"></el-image>
					<el-text style="margin: 1rem auto;">{{item.title}}</el-text>
				</div>
			</div>
		</div>
	</div>
	<div v-for="(item,index) in wallList">
		<SectionView class="section" 
			:imageSrc="item.imageUrl"
			:boxed="index == 0"
			:reverse="index%2==1" 
			:grayBackground="index == 0 ? false : index%2==0">
			<h3 class="title">{{item.title}}</h3>
			<ul class="list">
				<li v-for="info in item.summary"><span>{{info}}</span></li>
			</ul>
			<div v-if="index==0" class="video-play">
				<img src="@/assets/play.png" style="opacity:0.5;width:64px;" @click="handlePlay"/>
			</div>
		</SectionView>
	</div>
	<DeviceView />
	<h2 class="module-title">附加增值模块</h2>
	<ServiceView />
	
	<el-dialog class="video-player" v-model="playerVisible" top="0" width="1000px" append-to-body destroy-on-close>
		<video autoplay controls oncontextmenu="return false;" v-if="playerVisible" poster="@/assets/images/wall/ylgg56-video.jpg" style="height:100%;width:100%;">
			<source src="http://res.ylgg56.com/ylgg-tms-paas.mp4" style="height:100%;width:100%;"/>
		</video>
	</el-dialog>
  </div>
</template>

<script setup>
	import DeviceView from '@/components/DeviceView.vue'
	import ServiceView from '@/components/ServiceView.vue'
	import SectionView from '@/components/SectionView.vue'
	
	import bgHeader from '@/assets/images/bg_header.jpg'
	import foreHeader from '@/assets/images/bg_carousel.png'
	import iconImage1 from '@/assets/images/chengyunshangwodeyundan.png'
	import iconImage2 from '@/assets/images/chengyunshangwodedingdan.png'
	import iconImage3 from '@/assets/images/huozhuduanwodeyundan.png'
	import iconImage4 from '@/assets/images/chengyunshangjichushuju.png'
	
	import imgWall1 from '@/assets/images/wall/wall1.jpg'
	import imgWall2 from '@/assets/images/wall/wall2.png'
	import imgWall3 from '@/assets/images/wall/wall3.jpg'
	import imgWall4 from '@/assets/images/wall/wall4.png'
	import imgWall5 from '@/assets/images/wall/wall5.png'
	import imgWall6 from '@/assets/images/wall/wall-full.png'
	import imgWall7 from '@/assets/images/wall/wall7.png'
	import imgYlgg from '@/assets/images/wall/ylgg56-video.jpg'

	const iconList = ref([
		{ icon: iconImage2, title: '从发货到签收订单全流程管理' },
		{ icon: iconImage3, title: '完善的对账功能大幅节省对账时间' },
		{ icon: iconImage1, title: '实时在途追踪轨迹真实可信' },
		{ icon: iconImage4, title: '大数据智能贴合业务需求' }
	])
	
	const wallList = ref([
		{ imageUrl: imgYlgg, 
			title: '专业运输管理系统',
			summary: [
				'从货主到司机到客户的全链条全渠道真实管控！',
				'全程可视，实时追踪，提升终端客户满意度，节省对账时间。',
				'一路高歌TMS实施迅速，囊括承运商管理、运作管理、账单管理和大数据智能。'
			]
		},
		{
		  imageUrl: imgWall1,
		  title: '从发货到签收，订单全流程管理',
		  summary: [
		    '从货主、三方物流、承运商、司机再到客户，互联互通，一站式全链接',
		    '统一订单管理，数字化运输合同，实现自动订单分配',
		    '承运商统一管理，电脑端、APP、微信小程序多平台实时协同'
		  ]
		}, {
		  imageUrl: imgWall2,
		  title: '实时在途追踪，真实可信',
		  summary: [
		    '从发货到签收，实时在途追踪，确保信息真实可信',
		    '异常随时上报，送达握手交接，加速回单'
		  ]
		}, {
		  imageUrl: imgWall3,
		  title: '完善的对账功能，大幅节省对账时间',
		  summary: [
		    '强大计费引擎与完善的对账功能，支持一键生成账单，在线对账，大幅节省对账时间！',
		    '准确的账单金额，灵活的账单周期，规避结算误差！'
		  ]
		}, {
		  imageUrl: imgWall7,
		  title: '智慧车队管理',
		  summary: [
		    '通过数据分析，合理规划路线 ，更绿色、更环保',
		    '提高车辆的装载利用率和车辆运输效率',
		    '车辆维修、年审、保险到期预警，合理控制用车成本'
		  ]
		}, {
		  imageUrl: imgWall5,
		  title: '智能回单管理',
		  summary: [
		    '历史单据可搜索查询',
		    '智能分析与监控，简洁、直观、可视化',
		    '回单一站式管理'
		  ]
		}, {
		  imageUrl: imgWall4,
		  title: '大数据智能，贴合业务需求',
		  summary: [
		    '运输商务智能，提供免费标准运输报表',
		    '智能分析与监控，简洁、直观、可视化',
		    '可选企业自定义报表，贴合业务需求'
		  ]
		}, {
		  imageUrl: imgWall6,
		  title: '全面的评价系统',
		  summary: [
		    '根据评价大数据对司机、三方物流以及客户进行信用体系建设',
		    '为客户提供更好的服务', '做司机和三方物流的良好桥梁'
		  ]
		}
	])
	
	const playerVisible = ref(false);
	const handlePlay = () => {
		playerVisible.value = true 
	}
</script>

<style lang="scss" scoped>
	.module-title {
		color: #585C61;
		font-size: 32px;
		text-align: center;
		margin-top: 3rem;
		
		&:before {
			background-color: #585C61;
			content: "";
			display: block;
			height: 3px;
			position: absolute;
			margin-left: calc(50% - 50px);
			margin-top: -20px;
			width: 100px;
		}
	}
	
	.video-play {
		height: 64px;
		position: absolute;
		width: 64px;
		left: 278px;
		top: 160px;
		
		img {
			cursor: pointer;
		}
	}
	
	.el-carousel__item  {
	  color: #475669;
	  margin: 0;
	  text-align: center;
	  
	  .slider {
		  background-size: cover; 
		  height: 100%; 
		  width: 100%;
		  
		  .site-info {
			  background-repeat: no-repeat;
			  background-position: left center;
			  background-size: contain;
			  color: #fff;
			  height: 100%;
			  position: relative;
			  width: 100%;
			  
			  .site-info__content {
				  align-items: start;
				  display: flex;
				  flex-direction: column;
				  left: 280px;
				  position: absolute;
				  top: 35%;
				  
				  .title {
					  font-size: 38px;
				  }
				  .ulist {
					  list-style-type: none;
					  line-height: 42px;
					  padding: 0;
					  text-align: left;
					  font-size: 21px;
					  margin-top: 1rem;
				  }
			  }
		  }
	  }
	}
	
	.strip-line {
		background-color: #EF6336;
		height: 50px;
	}

	.sub-title {
		padding: 30px;
		position: relative;
		top: -80px;
		margin-bottom: -80px;
		
		.section {
			background-color: #fff;
			border-radius: 30px;
			box-shadow: 0 3px 16px -2px #d0cece;
			padding: 30px;
			margin: 0 1rem;
			
			.title {
				font-size: 32px;
				text-align: center;
			}
			.items { 
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				
				.icon-box {
					align-items: center;
					display: flex;
					flex-direction: column;
					justify-content: center;
					padding: 2rem 2rem 0;
				}
			}
		}
	}
	
	.section {
		.title {
			color: #1B1A19;
			font-size: 32px;
			font-weight: normal;
			margin-bottom: 2rem;
		}
		.list {
			font-size: 20px;
			padding-left: 1em;
			
			li {
				color: #fd5e0f;
				list-style-type: disc;
				padding: 0.75em 1em;
				
				span {
					color: #4F4F4F;
				}
			}
		}
	}
	
	.el-carousel__item:nth-child(2n) {
	  background-color: #EF6336;
	}
	
	.el-carousel__item:nth-child(2n + 1) {
	  background-color: #EF6336;
	}
</style>

<style lang="scss">
	.video-player {
	  ::v-deep .el-dialog {
		background-color: transparent;
	
		.el-dialog__header {
		  display: none;
		}
	
		.el-dialog__body {
		  padding: 0;
		}
	  }
	}
	
</style>